import { ToastFactory } from "./use-toast";

const commands = {
  showToast: ToastFactory().showToast,
  remove: ToastFactory().remove,
};

export const Hub = {
  show: (message, heading = "", options = {}) =>
    commands.showToast(message, heading, options),
  remove: (id) => commands.remove(id),
};
